export class DannoBiologico {
    patologia: string;
    dataDiagnosi: number;
    dataDecesso: number;
    riconoscimentoMalattiaProfessionale: boolean;
    dataRiconoscimentoMalattiaProfessionale: number;
    percentualeInvalidita: number;
    numeroGiorniInvaliditaTemp: number;
    dataRilevazioneInvaliditaTemp: number;
    importoDannoBiologico: number;
    importoDannoMorale: number;
    importoDannoMoraleEredi: number;
    importoInvaliditaTemp: number;
    note: string;
    totalePreAbbattimento: number;
    percentualeAbbattimento: number;
    totale: number;
    id: string;
}